import React from "react";
//import { action } from "mobx";
import { observer, inject } from "mobx-react";

@inject('postStore')
@observer
export default class PostListFilter extends React.Component {

    render() {
        let { postStore } = this.props;

        return (<div className="post-list-filter">{postStore.getFilter('type', 'information')}            
            <div data-filter="incident" className={"post-list-filter-type filter-type-incident" + (postStore.filterTypeIncident ? " active" : "")} onClick={() => { postStore.filterTypeIncident = !postStore.filterTypeIncident }}>Incident</div>
            <div data-filter="maintenance" className={"post-list-filter-type filter-type-maintenance" + (postStore.filterTypeMaintenance ? " active" : "")} onClick={() => { postStore.filterTypeMaintenance = !postStore.filterTypeMaintenance }}>Maintenance</div>
            <div data-filter="release" className={"post-list-filter-type filter-type-release" + (postStore.filterTypeRelease ? " active" : "")} onClick={() => { postStore.filterTypeRelease = !postStore.filterTypeRelease }}>Release</div>
            <div data-filter="information" className={"post-list-filter-type filter-type-information" + (postStore.filterTypeInformation ? " active" : "")} onClick={() => { postStore.filterTypeInformation = !postStore.filterTypeInformation }}>News</div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/PostListFilter.jsx